// File: LuxuryFeaturesSection.jsx
// Safe placeholders + premium travel features layout
import React from 'react';

import { ArrowBigRight, ArrowRightFromLine, ArrowUpRightFromCircle, ChevronRight, MonitorPlay, Notebook, Sailboat, SparkleIcon, ZapOff } from 'lucide-react';
const features = [
  { id: 1, title: 'IBPS', img: 'https://picsum.photos/400/550?random=501', icon: <Sailboat size={30} color={`rgba(144, 202, 249,1)`}/> },
  { id: 2, title: 'NABARD', img: 'https://picsum.photos/400/550?random=502', icon: <SparkleIcon size={30} color={`rgba(144, 202, 249,1)`}/> },
  { id: 3, title: 'SEBI',  img: 'https://picsum.photos/400/550?random=503',icon: <MonitorPlay size={30} color={`rgba(144, 202, 249,1)`}/> },
  { id: 4, title: 'RBI', img: 'https://picsum.photos/400/550?random=504', icon: <Notebook size={30} color={`rgba(144, 202, 249,1)`}/> },
//   { id: 5, title: 'SBI', img: 'https://picsum.photos/400/550?random=505', icon: <ZapOff size={30} color={`rgba(144, 202, 249,1)`}/> },

];

export default function CategoryCard5() {
  return (<>
    <section className="lux-sec-catc-5">
      <div className="lux-left">
        <p className="tag-catc-5">Our Features & Quality Details!</p>
        <h2 className="lux-title-catc-5">Few of our Quality Features<br/> & More!</h2>
        <p className="desc-catc-5">There are many variations of passages of Lorem ipsum available, but the majority have...</p>
        <button className="lux-btn-catc-5">View All Courses <ArrowUpRightFromCircle size={20} /></button>
      </div>

      <div className="lux-right-catc-5">
        {features.map((f) => (
          <div className="lux-card-catc-5" key={f.id}>
            <img src={f?.img} alt="travel" />
            <div className="lux-icon-catc-5">{f.icon}</div>
            <h4>{f.title}</h4>
          </div>
        ))}
      </div>
    </section>
    <style>{`
/* File: LuxuryFeaturesSection.css */


.lux-sec-catc-5 {margin-top:50px;
  background: rgba(144, 202, 249,0.31);
  padding: 30px 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
  color: #222222;
  font-family: Poppins, sans-serif;
}

.tag-catc-5 {
  font-size: 14px;
  opacity: .7;
  margin-bottom: 12px;
}

.lux-title-catc-5 {
  font-size: 36px;
  line-height: 1.2;
  font-weight: 800;
  margin-bottom: 20px;
}

.desc-catc-5 {
  font-size: 15px;
  width: 90%;
  opacity: .85;
  margin-bottom: 22px;
}

.lux-btn-catc-5 {
  border: none;display:flex;justify-content:space-between;gap:10px;
  background: rgba(144, 202, 249,1);
  padding: 12px 26px;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  font-weight: 700;
  transition: .3s;
}

.lux-btn-catc-5:hover {
  background: rgba(144, 202, 249,1);
}

.lux-right-catc-5 {
  display: flex;max-width:680px;flex-wrap:wrap;
  gap: 10px;
}

.lux-card-catc-5 {
  width: 150px;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  text-align: center;
  transition: .3s;
}

.lux-card-catc-5 img {
  width: 100%;
  height: 250px;
  object-fit: cover;
}

.lux-icon-catc-5 {
  width: 50px;
  height: 50px;
  background: #222222;
  
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 22px;
  font-weight: bold;
}

.lux-card-catc-5 h4 {
  font-size: 15px;
  font-weight: 700;
  margin-top: 24px;
}

.lux-card-catc-5:hover {
  transform: translateY(-8px);
}

@media(max-width:960px) {
  .lux-sec-catc-5 {
    flex-direction: column;padding: 30px 10px;
    text-align: center;
  }
  .desc-catc-5 { width: 100%; }
  .lux-right-catc-5 {
    flex-wrap: wrap;
    justify-content: center;
  }
}`}</style>
    </>
  );
}
